// extracted by mini-css-extract-plugin
module.exports = {"runSVG":"style-module--runSVG--2RaCA"};